import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import { IAdvBoxAttributes } from '../../../typings/adv';
import SportsDetailCard, { ISportsDetailCard } from '../../molecules/sports-detail-card/sports-detail-card';
import { makeClassNames } from '../../../utils/styles';
import { sportsDetailCardtypes, ICardsIntcmp } from '../../../typings/sports-detail';
import CardAdv from '../../atoms/card-adv/card-adv';
import { IDriver, ITeam } from '../../templates/season-ranking-page/season-ranking-page';
import { handleSeasonCard } from '../../../utils/season-card-utils';
import './gallery-tab.scss';

type Player = Omit<ISportsDetailCard, 'playerTeamImageUrl' | 'playerTeamName' | 'playerTeamColor'>;

export enum observedTypes {
  CARD = 'card',
  ADV = 'adv',
}

export interface ITeamContent {
  title: string;
  text: string;
}
export interface IFootballTeam {
  type: sportsDetailCardtypes;
  players: Player[];
  teamName: string;
  teamColor: string;
  teamImageUrl: string;
  teamContent?: ITeamContent[];
}

interface IGalleryTabProps {
  cards: IDriver[] | ITeam[];
  type: sportsDetailCardtypes;
  fakeAdvs?: boolean;
  advBoxAttributes?: IAdvBoxAttributes;
  trackingDataValues?: ICardsIntcmp;
}

const classNames = () =>
  makeClassNames({
    footballTeam: 'football-team',
    players: 'football-team__players',
    playerWrapper: 'football-team__player-wrapper',
    advMPU: 'football-team__adv-mpu',
    advNative: 'football-team__adv-native',
    paragraph: ['text', 'text--color-blue', 'text--font-size-16', 'text--weight-400'],
    advertising: 'c-label--advertisement',
  });

const cn = classNames();

const GalleryTab = forwardRef<unknown, IGalleryTabProps>((props: IGalleryTabProps, ref) => {
  const { cards, type, fakeAdvs, advBoxAttributes, trackingDataValues } = props;

  const isAdvMpu = (index: number): boolean => index % 2 === 1 && index < cards.length - 1;

  const cardsRef = useRef<HTMLDivElement[]>([]);

  const addToCardsRef = (element: HTMLDivElement) => {
    if (element && !cardsRef?.current?.includes(element)) {
      cardsRef.current.push(element);
    }
  };

  useImperativeHandle(ref, () => {
    return {
      cardsRef: cardsRef.current,
      handleSeasonCard,
      removeObserveType: (element: HTMLDivElement) => {
        element?.removeAttribute('data-observe-type');
      },
    };
  });

  return (
    <div className={cn.footballTeam}>
      <div className={cn.players}>
        {cards?.map((card: any, index: number) => (
          <div
            key={`card-${index}`}
            ref={addToCardsRef}
            className={cn.playerWrapper}
            data-observe-type={observedTypes.CARD}
            data-analytics-card={index + 1}
          >
            <SportsDetailCard
              type={type}
              imageUrl={card.imageUrl}
              lastName={card.lastName}
              firstName={card.firstName}
              url={card.url}
              mvp={card.mvp}
              logoUrl={card.logoUrl}
              teamName={card.teamName}
              teamUrl={card.teamUrl}
              backgroundColor={card.backgroundColor}
              points={card.points}
              showPoints
              position={card.position}
              role={card.role}
              label="punti"
              trackingDataValues={trackingDataValues}
            />
            {isAdvMpu(index) && (
              <div key={`advMPU-${index}`} className={cn.advMPU}>
                <CardAdv advBoxAttributes={advBoxAttributes || undefined} shiftingContent fakeAdvs={fakeAdvs} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
});

GalleryTab.displayName = 'GalleryTab';

export default GalleryTab;
